<template>
  <div class="sidebar">
    <i class="bi bi-list menu-icon" @click="togleMenu"></i>
    <transition name="slide">
      <div class="sidebar-expand-backdrop" v-if="isExpand">
        <div class="sidebar-expand shadow-sm">
          <i class="btn-close" @click="togleMenu"></i>
          <div class="menu-content">
            <div class="item-menu" @click="togleMenu">
              <div
                class="title"
                :class="{ selected: itemsMenus[0].selected }"
                @click="selectItem(itemsMenus[0])"
              >
                {{ itemsMenus[0].nome }}
              </div>
            </div>
            <div class="item-menu">
              <div
                class="title"
                :class="{ selected: itemsMenus[1].selected }"
                @click="selectItem(itemsMenus[1])"
              >
                {{ itemsMenus[1].nome }}
              </div>
              <transition name="slide-side" mode="out-in">
                <div class="item-expand" v-if="itemsMenus[1].selected">
                  <div class="title-expand">
                    Contribua com o memorial, deixe seu
                    depoimento/denúncia/sugestão abaixo.
                  </div>
                  <div
                    v-show="isLoadingForm && !isSubmit"
                    class="content-spiiner"
                  >
                    <div class="spinner-border text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <formio
                    v-show="!isLoadingForm && !isSubmit"
                    class="formio-form"
                    :src="formUrl"
                    @submit="onSubmitMethod"
                    @initialized="onInitialized"
                  />
                  <div v-if="isSubmit" class="content-spiiner resposta">
                    Resposta enviada!
                  </div>
                  <div class="fim"></div>
                </div>
              </transition>
            </div>
            <div class="item-menu">
              <div
                class="title"
                :class="{ selected: itemsMenus[2].selected }"
                @click="selectItem(itemsMenus[2])"
              >
                {{ itemsMenus[2].nome }}
              </div>
              <transition name="slide-side" mode="out-in">
                <div class="item-expand" v-if="itemsMenus[2].selected">
                  <div class="title-expand">Projeto Infovírus</div>
                  <!-- <div class="text">
                    Este memorial foi desenvolvido no âmbito do Projeto
                    "Infovírus: prisões e pandemia", que tem por objetivo a
                    denúncia e a checagem de informações que se tem disponíveis
                    sobre a situação da Covid-19 no sistema prisional
                    brasileiro.
                  </div> -->
                  <br />
                  <div class="d-flex">
                    <div class="right w-75">
                      <div class="title-expand">Quem faz parte</div>
                      <br />
                      <b>Universidade Federal de Santa Catarina</b>
                      <div><b>Reitor</b>: Prof. Ubaldo Cesar Balthazar</div>
                      <div>
                        <b>Vice-Reitora</b>: Profa. Alacoque Lorenzini Erdmannr
                      </div>
                      <br />
                      <b>Coordenação Geral do Projeto</b>
                      <div>Camila Cardoso de Mello Prando</div>
                      <div>Felipe Freitas</div>
                      <div>Marília de Nardin Budó</div>
                      <div>Riccardo Cappi</div>
                      <br />
                      <b>Coordenação Executiva </b>
                      <div>Felipe da Silva Freitas</div>
                      <div>Marília de Nardin Budó</div>
                      <br />
                      <b>Coordenação de Acervo </b>
                      <div>Letícia Borges Nedel</div>
                      <div>Renata Cardozo Padilha</div>
                      <div>Thainá Castro Costa Figueiredo Lopes</div>
                      <br />
                      <b>Pesquisa e conteúdo </b>
                      <div>Clarissa Torres Y Plá Trevas</div>
                      <div>Catarina Pedroso</div>
                      <div>Felipe da Silva Freitas</div>
                      <div>Karine Agatha França</div>
                      <div>Marília de Nardin Budó</div>
                      <div>Patrícia Silveira da Silva</div>
                      <div>Pietra Lima Inácio</div>
                      <br />
                      <b>Desenvolvimento e Design do Site</b>
                      <div>Lucas Monteiro</div>
                      <div>Raissa dos Santos</div>
                      <br />
                      <b>Arte Visual</b>
                      <div>Felipe Carvalho</div>
                      <br />
                      <b>Edição Audiovisual</b>
                      <div>Bee Martini</div>
                      <div>Ramon Zanirato</div>
                      <br />
                      <b>Revisão e Edição dos Textos</b>
                      <div>Camila Cardoso de Mello Prando</div>
                      <div>Felipe Freitas</div>
                      <div>Marília de Nardin Budó</div>
                      <br />
                      <b>Comunicação Social</b>
                      <div>Mariana Schreiner de Medeiros</div>
                      <div>Kauane Andressa Müller</div>
                      <br />
                      <b>Vozes</b>
                      <div>Camila Cardoso de Mello Prando</div>
                      <div>Felipe Freitas</div>
                      <br />
                      <b
                        >Estágio pela Bolsa Cultura (Secretaria de Cultura e
                        Arte da Universidade Federal de Santa Catarina)
                      </b>
                      <div>Mariana Schreiner de Medeiros</div>
                      <br />
                      <b>Financiamento do Projeto</b>
                      <div>
                        Fundo Brasil de Direitos Humanos (Edital Direitos
                        Humanos e Justiça Criminal/ 2021)
                      </div>
                      <br />
                      <b>Agradecimentos/Apoio</b>
                      <div>Rede de Justiça Criminal</div>
                      <div>Justa</div>
                      <div>
                        Núcleo de Execução Penal da Defensoria Pública do
                        Estados do Paraná (NUDEP/DPEPR)
                      </div>
                      <div>
                        Núcleo de Execução Penal da Defensoria Pública do Estado
                        do Rio Grande do Sul (DPERS)
                      </div>
                      <div>
                        Defensoria Pública do Estado de Santa Catarina (DPESC)
                      </div>
                      <div>
                        Defensoria Pública do Estado de São Paulo (DPESP)
                      </div>
                      <div>
                        Defensoria Pública do Estado de Pernambuco (DPEPE)
                      </div>
                      <div>Familiares de pessoas privadas de liberdade</div>
                      <div>
                        AMPARAR - Associação de Amigos/as e familiares de
                        presos/as (São Paulo)
                      </div>
                    </div>
                    <div class="left">
                      <img
                        class="image-logo"
                        src="@/assets/images/infovirus-logo.png"
                        alt="Logo Infovírus"
                      />
                      <br />
                      <br />
                      <img
                        width="114px"
                        class="image-logo"
                        src="@/assets/images/fundo-brasil.png"
                        alt="Logo Fundo Brasil"
                      />
                    </div>
                  </div>

                  <div class="fim"></div>
                </div>
              </transition>
            </div>
            <div class="item-menu">
              <div
                class="title"
                :class="{ selected: itemsMenus[3].selected }"
                @click="selectItem(itemsMenus[3])"
              >
                {{ itemsMenus[3].nome }}
              </div>
              <transition name="slide-side" mode="out-in">
                <div class="item-expand" v-if="itemsMenus[3].selected">
                  <div class="grid-memeoriais">
                    <!-- <a
                      href="http://memorialdademocracia.com.br/#"
                      target="_blank"
                    >
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial1.png"
                        alt=""
                      />
                    </a> -->
                    <a
                      href="https://www2.museudapessoa.org/exposicoes/diarios-da-pandemia/"
                      target="_blank"
                    >
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial2.png"
                        alt=""
                      />
                    </a>
                    <a
                      href="https://www.massacrecarandiru.org.br/"
                      target="_blank"
                    >
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial3.png"
                        alt=""
                      />
                    </a>
                    <!-- <a
                      href="https://memoriasdaditadura.org.br/memorial-mortos-e-desaparecidos/"
                      target="_blank"
                    >
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial4.png"
                        alt=""
                      />
                    </a> -->
                    <a href="https://deixadosparamorrer.org/" target="_blank">
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial5.png"
                        alt=""
                      />
                    </a>
                    <!-- <a
                      href="https://dosencontrosimpossiveis.art.br/"
                      target="_blank"
                    >
                      <img
                        class="image-logo-memorial"
                        src="@/assets/images/memorial6.png"
                        alt=""
                      />
                    </a> -->
                  </div>
                  <!-- <a
                    class="memorial-text"
                    href="https://expo-virtual-cpdoc.fgv.br/"
                    target="_blank"
                  >
                    <h3 class="my-5 text-center">Exposição Virtual - CPDOC</h3>
                  </a> -->
                  <div class="fim"></div>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="backdrop" @click="closeMenu"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Form } from "vue-formio";
export default {
  components: { formio: Form },
  data() {
    return {
      isExpand: false,
      isLoadingForm: true,
      isSubmit: false,
      formSucess: false,
      formUrl: "https://vtzhrtglzqjnkvm.form.io/infovirusform",
      itemsMenus: [
        { nome: "INÍCIO", selected: true },
        { nome: "CONSTRUA CONOSCO", selected: false },
        { nome: "QUEM SOMOS", selected: false },
        { nome: "OUTRAS EXPOSIÇÕES", selected: false },
      ],
    };
  },
  mounted() {},
  methods: {
    togleMenu() {
      this.isExpand = !this.isExpand;
    },
    closeMenu() {
      this.isExpand = false;
    },
    selectItem(clicked) {
      this.itemsMenus.forEach((item) => {
        item.selected = false;
      });
      clicked.selected = true;
    },
    onSubmitMethod(submission) {
      this.isSubmit = true;
      if (submission.state === "submitted") {
        this.formSucess = true;
      } else {
        this.formSucess = false;
      }
    },
    onInitialized() {
      this.isLoadingForm = false;
    },
  },
  watch: {
    isExpand(value) {
      if (!value) {
        this.selectItem(this.itemsMenus[0]);
        this.isLoadingForm = true;
        this.isSubmit = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-icon {
  color: white;
  position: fixed;
  padding: 0.3rem;
  left: 10px;
  cursor: pointer;
  z-index: 100;
  font-size: 2.2rem;

  &::before {
    background-color: #dc793a;
    border-radius: 5px;
  }
}

.content-spiiner {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 250px;

  &.resposta {
    font-size: 1.5rem;
    color: #3da324;
    height: 100px;
  }
}
.menu-content {
  width: 650px;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 0 30px;
  padding-top: 70px;
}

.grid-memeoriais {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;
  row-gap: 20px;
  margin-top: 15px;
  padding: 0 40px;
  justify-items: center;
}

.item-expand {
  width: 100%;
  padding: 5px;
  margin-top: 15px;
  .title-expand {
    font-family: Roboto Mono;
  }

  .text {
    margin-top: 5px;
    line-height: 1.1;
  }

  .fim {
    margin: 15px 0 5px;
    width: 100%;
    height: 1px;
    background-color: #dc783a56;
  }
}

.item-menu {
  .title {
    background-color: #f5f5f5;

    font-family: Roboto Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    color: black;

    &.selected {
      background-color: #dc793a;
      color: white;
    }
  }
}

.memorial-text {
  color: #dc793a;
  text-decoration: none;
}
.sidebar-expand {
  position: fixed;
  top: 0;
  left: 0;
  width: 600px;
  height: 100vh;
  background: white;
  z-index: 99999;
  overflow-y: auto;
  display: flex;
  justify-content: center;
}

.sidebar-expand-backdrop {
  z-index: 99999;
  width: 100%;
  position: fixed;
  height: 100vh;
}

.backdrop {
  width: 100%;
  height: 100vh;
}

.btn-close {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 2.6rem !important;
  height: 2.6rem !important;
  cursor: pointer;
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.slide-side-enter-active,
.slide-side-leave-active {
  transition: transform 0.2s ease;
  transform-origin: top top;
}

.slide-side-enter,
.slide-side-leave-to {
  transform: scaleY(0.5);
  transform-origin: top top;
  transition: all 150ms ease-in 0s;
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #a5a5a5;
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
  .menu-content {
    width: 100%;
  }

  .sidebar-expand {
    width: 100vw;
  }

  .menu-icon {
    top: 5px;
    left: 5px;
    background-color: #ffffff5d;
    font-size: 1.7rem;
    padding: 4px;
    line-height: 0.75;
  }

  .image-logo-memorial {
    width: 100px;
  }
}
</style>